// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_gz-0";